import { Action, Mutation, Module, VuexModule } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import {AxiosRequestConfig} from 'axios'

interface Otp {
  //password: string;
  ref: string;
  token: string;
  createdAt: Date;
  expiredAt: Date;
}

interface StoreInfo {
  otp: Otp;
}

@Module
export default class OtpModule extends VuexModule implements StoreInfo {
  otp = {} as Otp;
  /**
   * Get breadcrumb object for current page
   * @returns object
   */
  get getOtp(): Otp {
    return this.otp;
  }

  /**
   * Get breadcrumb array for current page
   * @returns string
   */
  get token(): string {
    return this.otp.token;
  }


  @Mutation
  [Mutations.SET_OTP](payload) {
    console.log(payload)
    this.otp = payload;
  }

  @Mutation
  [Mutations.SET_OTP_TOKEN](payload) {
    this.otp.token = payload;
  }


  @Action
  [Actions.REQUEST_OTP](payload) {    
    return new Promise<void>((resolve, reject) => {
      ApiService.post("otp", payload)
        .then(({data}) => {
          this.context.commit(Mutations.SET_OTP, data);
          resolve()
        })
        .catch(({response}) => {
          reject(response.data.message);
        })
    })
  }

  @Action
  [Actions.VERIFY_OTP](payload) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("otp/verify", payload)
        .then(({data}) => {
          this.context.commit(Mutations.SET_OTP, data.token);
          resolve()
        })
        .catch(({response}) => {
          console.log(response)
          reject(response.data.message);
        })
        
    })
  }



}
